import styled from 'styled-components';
import { Text, Button } from '../../atoms';
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
export const Title = styled(Text)`
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 10px;
`;
export const Message = styled(Text)`
  margin-bottom: 20px;
  font-size: 14px;
`;
export const OKButton = styled(Button)`
  font-size: 12px;
  text-transform: uppercase;
`;